import { enums } from '../../../enums/index';

export const checkUserIsAdmin = (authentication, user) => {
  if ( authentication && (user.roles.includes(enums.UserRole.ADMIN) || user.roles.includes(enums.UserRole.SUPER_ADMIN)) ) {
    return true;
  }
  else return false
}

export const checkUserIsSuperAdmin = (authentication, user) => {
  if (authentication && user.roles.includes(enums.UserRole.SUPER_ADMIN))
    return true;
  else return false
}

export const checkUserIsDefinedAndAdmin = (user) => {
  return (user) && (user.roles.includes(enums.UserRole.ADMIN));
}

export const checkUserIsSuperAdminWithoutAuthentication = (user) => {
  return user.roles.includes(enums.UserRole.SUPER_ADMIN);
}


export const checkUserIsDefinedAndAdminOrSuperAdmin = (user) => {
  return (user) && (user.roles.includes(enums.UserRole.ADMIN) || user.roles.includes(enums.UserRole.SUPER_ADMIN));
}




// WEBPACK FOOTER //
// ./src/utils/user/checkAdmin/CheckAdmin.js